import _ from 'lodash';
import { MessageApi } from '../../util/api/MessageApi';
import { Alert } from "../Alert"


class Message {
    id = null;
    emailBody = "";
    emailSubject = "";
    studentIds = [];
    senderName = "";
    senderTuid = "";
    createdDate = null;



    constructor(employer = {}) {
        //Adds any default values passed by the developer 
        _.defaults(this, employer);
    }

    async save(appStore) {
        const api = MessageApi;

        try {
            let response = await api.add(this);

            let alert = new Alert("Success", "Email(s) sent successfully.");
            appStore.addAlert(alert);

            await appStore.getFromApi(["messages"]);

            return response;
        }
        catch (error) {
            console.log(error)

            if (error.response) {
                console.log(error.response)
                let alert = new Alert("Error", error.response.statusText);
            }

            let alert = new Alert("Network Error", error);

            appStore.addAlert(alert);

            return false;
        }

    }
}

export default Message;